document.addEventListener("turbo:before-cache", function() {
  if (kModal.ModalOverlay) {
    kModal.remove();
  }
});
